import AppHeader from 'components/AppHeader'
import AppFooter from 'components/AppFooter'

import InputQuantity from 'components/InputQuantity'
import InputValidate from 'components/InputValidate'
import FileValidate from 'components/FileValidate'
import SelectValidate from 'components/SelectValidate'
import InputNumber from 'components/InputNumber'

import VueRecaptcha from 'vue-recaptcha'
import DatePicker from 'vuejs-datepicker'
import Timepicker from 'vue2-timepicker'

import Slick from 'vue-slick'
import { swiper, swiperSlide } from 'vue-awesome-swiper'

import Modal from 'components/Modal'
import ModalVideo from 'components/ModalVideo'
import ModalConfirm from 'components/ModalConfirm'
import ModalError from 'components/ModalError'

import ShareButtons from 'components/ShareButtons'
import Price from 'components/Price'

import Loading from 'components/Loading'
import PulseLoader from 'vue-spinner/src/PulseLoader'
import ClipLoader from 'vue-spinner/src/ClipLoader'
import SyncLoader from 'vue-spinner/src/SyncLoader'

import { headroom } from 'vue-headroom'

export default function registerComponents (Vue) {
  Vue.component('app-footer', AppFooter)
  Vue.component('app-header', AppHeader)
  Vue.component('headroom', headroom)

  Vue.component('input-quantity', InputQuantity)
  Vue.component('input-validate', InputValidate)
  Vue.component('file-validate', FileValidate)
  Vue.component('select-validate', SelectValidate)
  Vue.component('input-number', InputNumber)

  Vue.component('modal', Modal)
  Vue.component('modal-video', ModalVideo)
  Vue.component('modal-confirm', ModalConfirm)
  Vue.component('modal-error', ModalError)

  Vue.component('share-buttons', ShareButtons)
  Vue.component('price', Price)

  Vue.component('swiper-slide', swiperSlide)
  Vue.component('swiper', swiper)
  Vue.component('slick', Slick)

  Vue.component('vue-recaptcha', VueRecaptcha)
  Vue.component('datepicker', DatePicker)
  Vue.component('timepicker', Timepicker)

  Vue.component('loading', Loading)
  Vue.component('pulse-loader', PulseLoader)
  Vue.component('clip-loader', ClipLoader)
  Vue.component('sync-loader', SyncLoader)
}



// WEBPACK FOOTER //
// ./src/app/config/registerComponents.js